import React, { Component } from 'react';
import { withEventState } from 'src/ver2/pages/event/context';
import { Brikets } from '../Brikets';
import './style.css';

// import { Avatar, Modal, Button, Input, Tabs, Radio } from 'antd';

class MultyJudgePanel extends Component {

    state = {
        categorys: null,
        blockCount: 0,
        maxInBlock: 0
    }

    componentDidMount = () => {
        const { category, Categorys } = this.props;
        const { TimeStart } = category;

        const categorys = Categorys.filter(x => x.TimeStart === TimeStart);
        let blockCount = 0;
        let maxInBlock = 1;

        for (let i = 0; i < categorys.length; i++) {
            const { Id } = categorys[i];
            const count = this.getCountInCategory(Id);
            let bl = 1;
            if (count > 2) bl = 3;
            if (count > 3) maxInBlock = 2;
            if (count > 4) bl = 5;
            blockCount = Math.max(blockCount, bl);
        }
        this.setState({
            categorys,
            blockCount,
            maxInBlock
        })
    }

    render() {
        const { props } = this;
        const { categorys, blockCount, maxInBlock } = this.state;
        if (!categorys) return <div>гружу</div>

        return <div className='multyjudge_panel'>
            {categorys.map(category => {
                const { Id, Name } = category;
                return <div className='multyjudge_panel_one' key={`mjpo_${Id}`}>
                    <div className='multyjudge_panel_one_name'>{Name}</div>
                    <Brikets
                        {...props}
                        category={category}
                        selectedCategory={Id}
                        key={Id}
                        blockCount = {blockCount}
                        maxInBlock = {maxInBlock}
                    />
                </div>
            })}
        </div>
    }

    getCountInCategory = (id) => {
        const { competitorsCountInCategorys, isCompetitorsCountInCategorysReady } = this.props;
        if (!isCompetitorsCountInCategorysReady || !competitorsCountInCategorys) return 0;
        const findedCount = competitorsCountInCategorys.find(x => x.CategoryId === id);
        if (findedCount) return findedCount.count;
        return 0;
    }

}

export default withEventState(`
    Categorys, 
    competitorsCountInCategorys,
    isCompetitorsCountInCategorysReady,
    iAmAdmin
`)(MultyJudgePanel)